import React, { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import $ from 'jquery';
import 'bootstrap-select/dist/css/bootstrap-select.min.css';
import 'bootstrap-select/dist/js/bootstrap-select.min.js';

import { Spinner } from '../../components'
import { useForm } from 'react-hook-form'
import { clearAll, onSendLetterEval, showLetterEvaluationFormFunc } from '../../../config/redux/slice/appSlice';
import { useNavigate } from 'react-router-dom';
import { appUrls } from '../../../utils/urls/appUrls';
import { getStaffList, sendLetter } from '../../../config/redux/actions/notap';
import { LETTER_DIRECTION, LETTER_TYPE, ROLES } from '../../../constants';
import { setErrorMessageNotapUser } from '../../../config/redux/slice/notapUserSlice';
import { mapDataToFormData } from '../../../utils/lib';

export default function SendConfirmationModal({ is_modal, is_new_letter, resetValues, letterData, onCloseModal }) {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { register, handleSubmit, watch, setValue, formState: { errors } } = useForm({ mode: 'onTouched' });
    const { userLoading, digitalLetterManagement: { generalLetterDetails, draftLetterDetails} } = useSelector((state) => state.app);
    const { staff, notapUserLoading, notapUserErrorMsg } = useSelector((state) => state.notapUser);
    const { userData: { user_role, user_role_id, email }} = useSelector((state) => state.authData);

    const flowTypeValue = watch('flowType');

    const letterDetails = useMemo(() => {
        if (letterData.letterType === LETTER_TYPE.DRAFT) {
            return draftLetterDetails;
        }

        return generalLetterDetails;
    }, [letterData, generalLetterDetails, draftLetterDetails]);

    const notapStaff = useMemo(() => {
        return staff.filter((user) => user.EMAIL !== email && user.USER_ROLE_TEXT !== ROLES.DG.TEXT);
    }, [staff, email]);

    const officers = useMemo(() => {
        const isDeputyDirector = user_role === ROLES.DEPUTY_DIRECTOR.TEXT;
        const isForwardLetter = letterDetails.LETTER_DIRECTION === LETTER_DIRECTION.FORWARD || is_new_letter;

        if (isDeputyDirector && isForwardLetter) {
            return staff.filter((user) => user.USER_ROLE_TEXT === ROLES.OFFICERS.TEXT)
        }

        return [];
    }, [staff, user_role, letterDetails, is_new_letter]);
    
    const deputyDirectors = useMemo(() => {
        const isDirector = user_role === ROLES.DIRECTOR.TEXT;
        const isOfficer = user_role === ROLES.OFFICERS.TEXT;

        if (isDirector || isOfficer) {
            return staff.filter((user) => user.USER_ROLE_TEXT === ROLES.DEPUTY_DIRECTOR.TEXT);
        }

        return [];
    }, [staff, user_role]);

    const defaultNextStaff = useMemo(() => {
        const getNextStaffId = () => {
            if (is_new_letter) {
                if (user_role === ROLES.OFFICERS.TEXT) {
                    return -1;
                }

                return 1;
            }
    
            if (user_role === ROLES.OFFICERS.TEXT) {
                return -1;
            }
    
            if ([ROLES.DG.TEXT, ROLES.DIRECTOR.TEXT].includes(user_role)) {
                return 1;
            }
    
            if (letterDetails?.LETTER_DIRECTION === LETTER_DIRECTION.BACKWARD) {
                return -1
            }
            
            return 1;
        };

        return staff.find((user) => (parseInt(user_role_id) + getNextStaffId()) === parseInt(user.USER_ROLE_ID));
    }, [user_role_id, user_role, is_new_letter, letterDetails, staff]);

    const handleCloseModal = useCallback(() => {
        dispatch(setErrorMessageNotapUser({ message: '' }));
        onCloseModal();
    }, [dispatch]);

    const onSend = async (data) => {
        dispatch(clearAll({}));
    
        const getNextStaff = () => {
            if (data.flowType === 'option1') {
                const isPermitted = ['dg', 'director', 'deputydirector', 'officers'].includes(user_role.toLowerCase());
                
                if (isPermitted) {
                    if (data.next_notap_staff) return data.next_notap_staff

                    return defaultNextStaff.EMAIL
                }
            }

            if (data.flowType === 'option3') {
                return '';
            }

            return data.next_notap_staff;
        };

        const getLetterDirection = () => {
            if (data.flowType === 'option3') {
                return LETTER_DIRECTION.FORWARD;
            }

            if ([ROLES.DG.TEXT, ROLES.DIRECTOR.TEXT].includes(user_role)) {
                return LETTER_DIRECTION.FORWARD
            }

            if (user_role === ROLES.OFFICERS.TEXT) {
                return LETTER_DIRECTION.BACKWARD;
            }

            if (user_role === ROLES.DEPUTY_DIRECTOR.TEXT){
                let nextStaff = notapStaff.find((staff) => staff.EMAIL === getNextStaff());

                if (nextStaff && (nextStaff.USER_ROLE_TEXT === ROLES.OFFICERS.TEXT)) {
                    return LETTER_DIRECTION.FORWARD;
                }

                return LETTER_DIRECTION.BACKWARD;
            }

            return LETTER_DIRECTION.FORWARD;
        };

        const getStatus = () => {
            if (data.status === LETTER_TYPE.DRAFT || data.flowType === 'option3') {
                return data.status;
            } 

            return 'next_user';
        };

        const getMessageFromStatus = (status, defaultMessage) => {
            if (status === LETTER_TYPE.SEND_MESSAGE) {
                return 'Letter Sent To Third Party Successfully!';
            }
        
            if (status === LETTER_TYPE.NEXT_USER) {
                return 'Award Letter Sent Successfully!';
            }

            if (status === LETTER_TYPE.DRAFT) {
                return 'Letter saved successfully!';
            }

            return defaultMessage;
        };

        const apiData = {
            ...letterData,
            next_notap_staff: getNextStaff(),
            letter_direction: getLetterDirection(),
            status: getStatus(),
        };

        const formData = mapDataToFormData(apiData);
        const resultAction = await dispatch(sendLetter(formData));
        
        if (sendLetter.fulfilled.match(resultAction)) {
            resetValues();
            
            dispatch(onSendLetterEval({
                message: getMessageFromStatus(formData.get('status'), resultAction.payload.message), 
                email: formData.get("next_notap_staff"), 
                unseen: 'Letter Added Successfully'
            }));

            if (!is_modal && !is_new_letter) {
                return navigate(`${appUrls.digitalLetterBase}?tab=inbox`);
            }

            handleCloseModal();
            dispatch(showLetterEvaluationFormFunc({ modal: false }));
        }
    };
    
    useEffect(() => {
        dispatch(clearAll({}));
        dispatch(getStaffList());
    }, [dispatch]);

    useEffect(()=>{
        if(!notapUserLoading){
            $(function () {
                $('.my-staff-select').selectpicker('destroy');
                $('.my-director-select').selectpicker('destroy');
            });
        }
    }, [notapUserLoading]);

    useEffect(() => {
        if(user_role === ROLES.DEPUTY_DIRECTOR.TEXT) {
            $(function () {
                $('.my-staff-select').selectpicker();
            });
        }
    }, [user_role]);

    useEffect(() => {
        function initPicker() {
            if (flowTypeValue === 'option2') {
                $(function () {
                    $('.my-director-select').selectpicker('destroy');
                    $('.my-staff-select').selectpicker();
                });

                return;
            }

            const isPermitted = [ROLES.DIRECTOR.TEXT, ROLES.OFFICERS.TEXT].includes(user_role);
            if (flowTypeValue === 'option1' && isPermitted && notapStaff.length !== 0) {
                $(function () {
                    $('.my-staff-select').selectpicker('destroy');
                    $('.my-director-select').selectpicker();
                });
            }

        }
        
        initPicker();
    }, [flowTypeValue, notapStaff, user_role]);

    return (
        <div 
            className="modal fade show" 
            id="basicModal" 
            tabIndex="-1"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
            style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.3)",
            overflowY: 'auto'
            }}
        >
            <div style={{overflowY: 'auto'}} className="modal-dialog modal-dialog-centered modal-md" role="document">
                <div className="modal-content">
                    <form onSubmit={handleSubmit(onSend)} autoComplete={'off'} noValidate>
                        <div className="modal-header px-4">
                            <h5 className="modal-title" id="exampleModalCenterTitle">Send Evaluation</h5>
                            <button 
                                type="button" 
                                className="close" 
                                data-dismiss="modal" 
                                aria-label="Close"
                                onClick={handleCloseModal}
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        
                        <div className='modal-body'>
                        <div className="form-check form-check-inline">
                            <input 
                                className="form-check-input" 
                                type="radio" 
                                id="exampleRadios1" 
                                defaultChecked={true}
                                value="option1"
                                {...register(`${'flowType'}`, {
                                    required: {
                                        value: true,
                                        message: '*this field is required'
                                    }
                                })}
                            />
                            <label className="form-check-label" htmlFor="exampleRadios1">
                                Follow default flow
                            </label>
                            </div>   
                            
                            {[ROLES.DG.TEXT, ROLES.DIRECTOR.TEXT].includes(user_role) && (
                                <div className="form-check form-check-inline">
                                    <input 
                                        className="form-check-input" 
                                        type="radio" 
                                        id="exampleRadios2" 
                                        value="option2"
                                        {...register(`${'flowType'}`, {
                                            required: {
                                                value: true,
                                                message: '*this field is required'
                                                }
                                        })}
                                    />
                                    <label className="form-check-label" htmlFor="exampleRadios2">
                                        Send to a different staff
                                    </label>
                                </div>
                            )}
                            
                            {user_role === ROLES.DIRECTOR.TEXT && (
                                <div className="form-check form-check-inline">
                                    <input 
                                        className="form-check-input" 
                                        type="radio" 
                                        id="exampleRadios3" 
                                        value="option3"
                                        {...register(`${'flowType'}`, {
                                            required: {
                                                value: true,
                                                message: '*this field is required'
                                            }
                                        })}
                                    />
                                    <label className="form-check-label" htmlFor="exampleRadios3">
                                        Send to third party
                                    </label>
                                </div>
                            )}

                            <>{(flowTypeValue == 'option2' || (user_role.toLowerCase() == 'deputydirector' && (letterDetails.LETTER_DIRECTION == 'forward' || is_new_letter))) &&
                                <div className="form-group mt-2">
                                    <label htmlFor='next_notap_staff'>
                                        {user_role.toLowerCase() == 'deputydirector' ? 'Officers' : 'Staff'}
                                    </label>
                                    <select 
                                        disabled={notapUserLoading}
                                        className="form-control rounded-0 selectpicker my-staff-select" 
                                        id="next_notap_staff"
                                        data-live-search={!notapUserLoading}
                                        {...register("next_notap_staff", {
                                            required: {
                                            value: true,
                                            message: '*this field is required'
                                            }
                                        })} 
                                    >
                                        {!notapUserLoading ?
                                    <option value=''>{user_role === ROLES.DEPUTY_DIRECTOR.TEXT ? 'Select Officer' : 'Select Staff'}</option>
                                    :
                                    <option data-content={`<div style='display:flex; align-items: center;'>
                                                        <span class='mr-2 text-capitalize'>Loading</span>
                                                        <div>
                                                        <div class="sk-fading-circle" style='width: 15px; height: 15px;'>
                                                            <div class="sk-circle1 sk-circle"></div>
                                                            <div class="sk-circle2 sk-circle"></div>
                                                            <div class="sk-circle3 sk-circle"></div>
                                                            <div class="sk-circle4 sk-circle"></div>
                                                            <div class="sk-circle5 sk-circle"></div>
                                                            <div class="sk-circle6 sk-circle"></div>
                                                            <div class="sk-circle7 sk-circle"></div>
                                                            <div class="sk-circle8 sk-circle"></div>
                                                            <div class="sk-circle9 sk-circle"></div>
                                                            <div class="sk-circle10 sk-circle"></div>
                                                            <div class="sk-circle11 sk-circle"></div>
                                                            <div class="sk-circle12 sk-circle"></div>
                                                        </div>
                                                        </div>
                                                        </div>` }
                                        value={'loading'}>
                                        Loading...
                                    </option>}
                                    {user_role === ROLES.DEPUTY_DIRECTOR.TEXT ?
                                        <>
                                            {officers.map((notapItem, i) => (
                                                <option 
                                                    datatokens={`${notapItem.FIRST_NAME} ${notapItem.LAST_NAME} ${notapItem.EMAIL}`} 
                                                    key={i} 
                                                    value={notapItem.EMAIL}>
                                                        {notapItem.FIRST_NAME} {notapItem.LAST_NAME} ({notapItem.USER_ROLE_TEXT})
                                                </option>)
                                            )}
                                        </>
                                        :
                                        <>
                                            {notapStaff.map((notapItem, i)=>{
                                                return <option datatokens={`${notapItem.FIRST_NAME} ${notapItem.LAST_NAME} ${notapItem.EMAIL}`} key={i} value={notapItem.EMAIL}>{notapItem.FIRST_NAME} {notapItem.LAST_NAME} ({notapItem.USER_ROLE_TEXT})</option>
                                            })}
                                        </>
                                    }
                                    </select>
                                    {
                                    errors?.next_notap_staff?.message &&
                                    <div className="text-danger small mt-1">
                                        {errors?.next_notap_staff?.message}
                                    </div>
                                    }
                                </div>
                            }</>

                            <>{(flowTypeValue == 'option1' && (user_role.toLowerCase() == 'director' || user_role.toLowerCase() == 'officers')) &&
                                <div className="form-group mt-2">
                                    <label htmlFor='next_notap_staff'>Deputy Directors</label>
                                    <select 
                                    disabled={notapUserLoading}
                                    className="form-control rounded-0 selectpicker my-director-select" 
                                    id="next_notap_staff"
                                    data-live-search={!notapUserLoading}
                                    {...register("next_notap_staff", {
                                        required: {
                                        value: true,
                                        message: '*this field is required'
                                        }
                                    })
                                    } 
                                    >
                                        {!notapUserLoading ?
                                    <option value={''}>Select Deputy Director</option>
                                    :
                                    <option data-content={`<div style='display:flex; align-items: center;'>
                                                        <span class='mr-2 text-capitalize'>Loading</span>
                                                        <div>
                                                        <div class="sk-fading-circle" style='width: 15px; height: 15px;'>
                                                            <div class="sk-circle1 sk-circle"></div>
                                                            <div class="sk-circle2 sk-circle"></div>
                                                            <div class="sk-circle3 sk-circle"></div>
                                                            <div class="sk-circle4 sk-circle"></div>
                                                            <div class="sk-circle5 sk-circle"></div>
                                                            <div class="sk-circle6 sk-circle"></div>
                                                            <div class="sk-circle7 sk-circle"></div>
                                                            <div class="sk-circle8 sk-circle"></div>
                                                            <div class="sk-circle9 sk-circle"></div>
                                                            <div class="sk-circle10 sk-circle"></div>
                                                            <div class="sk-circle11 sk-circle"></div>
                                                            <div class="sk-circle12 sk-circle"></div>
                                                        </div>
                                                        </div>
                                                        </div>` }
                                        value={'loading'}>
                                        Loading...
                                    </option>}
                                    {deputyDirectors.map((notapItem, i)=>{
                                        return <option datatokens={`${notapItem.FIRST_NAME} ${notapItem.LAST_NAME} ${notapItem.EMAIL}`} key={i} value={notapItem.EMAIL}>{notapItem.FIRST_NAME} {notapItem.LAST_NAME} ({notapItem.USER_ROLE_TEXT})</option>
                                    })}
                                    </select>
                                    {
                                    errors?.next_notap_staff?.message &&
                                    <div className="text-danger small mt-1">
                                        {errors?.next_notap_staff?.message}
                                    </div>
                                    }
                                </div>
                            }</>
                        </div>
                        
                        {notapUserErrorMsg && (
                            <div className="px-4 mb-4">
                                <div className="alert alert-danger" role="alert">
                                    {notapUserErrorMsg}
                                </div>
                            </div>
                        )}

                        <div className="modal-footer px-4 d-flex align-items-center">
                            {(userLoading || notapUserLoading) 
                                ?  <Spinner/> 
                                : (
                                    <>
                                        <div>
                                            <button onClick={() => setValue('status', 'draft')} type="submit" className="btn btn-danger">
                                                Save
                                            </button>
                                        </div>

                                        <div>
                                            {notapUserLoading ? <Spinner/> : <button onClick={() => setValue('status', 'send_message')} type="submit" className="btn btn-success">Send</button>}
                                        </div>
                                    </>
                                )}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}